import { IContact } from "@rentiohq/shared-frontend/dist/types/contact.types";
import { IBrokerKybInfo } from "@rentiohq/shared-frontend/dist/types/payment.types";

export interface IExtraData {
  contact: IContact;
  // DEV-2801: a legal Mangopay user does Mangopay's hosted KYB instead of uploading ID cards
  isLegalUser?: boolean;
  kybInfo?: IBrokerKybInfo;
}

export enum EField {
  DateOfBirth = "dateOfBirth",
  Nationality = "nationality",
  Address = "address",
  IdCardInfo = "IdCardInfo",
  IdCardFront = "IdCardFront",
  IdCardBack = "IdCardBack",
  KybWhyInfo = "kybWhyInfo",
  KybPrepareInfo = "kybPrepareInfo",
  KybRepresentativeInfo = "kybRepresentativeInfo",
  KybDocumentsInfo = "kybDocumentsInfo",
}
